<template>
    <div id="audio-player-root" >

        <!-- Hide the default audio player -->
        <div v-if="url">
            <audio
                style="display:none"
                ref="player"
                :id="playerid"
            >
                <source :src="url" type="audio/mpeg" />
            </audio>
        </div>
            
            <div>
                <div id="player-row" class="widthbox">
                    <v-layout>
                        <v-flex lg12 xs12 md12 class="mt-lg-2 ml-lg-0">
                    <div id="button-div" class="">

                     <span class="font-18">  {{numberSeq}} <span class="font-weight-bold" style="color:#8BDCFF; "> {{wordAudio}} </span> <v-icon medium color="white" @click="toggleAudio()"> mdi-volume-high </v-icon>
                     </span> 
                     <div class="font-12 mt-2"> {{transOne ? transOne : translatedTxt}} <span v-if="getDif">「{{getDif.pos}}」</span> </div> 
                    <div class="font-12 mt-2 text-lg-body-2" v-if="getDif"> {{getDif.sense.definition}} </div>
                    </div>
                        </v-flex>
                    
                    </v-layout>
                    </div>
                </div>
                   
            
            <!-- outer gray border -->
        </div>
        <!-- white bg -->
    <!-- </div> -->
    <!-- root -->
</template>
<script>
//import { mapState } from 'vuex'
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    props: ["url", "playerid","wordAudio","numberSeq","texttospeech","transOne"],
    /**
     * playbackTime = local var that syncs to audio.currentTime
     * audioDuration = duration of audio file in seconds
     * isPlaying = boolean (true if audio is playing)
     *
     **/

    data() {
        return {
            playbackTime: 0,
            audioDuration: 100,
            audioLoaded: false,
            isPlaying: false,
            translatedTxt:'',
            getDif:'',
            pos:'',
            voices:'',

        };
    },
    watch:{
        
    },
    methods: {

        // set dictionary def
        async getDictionaryDef(word){
                axios.get("https://ueducms.org/content-utilities/api/dictionary-proxy/"+word)
                    .then(rs => {

                            this.getDif = rs.data.item[0]
                            
                    }).catch(error=>console.log('this is the error '+error));
        },

        async getpapago(){
            axios.get('https://phone.megatalking.com/origin/api/papago-api.php?word='+this.wordAudio)
        //.then(response=>console.warn(response.data))
        .then(response=>{
        this.translatedTxt = response.data.message.result.translatedText
        // console.log(this.translatedTxt)
            this.getDictionaryDef(response.data.message.result.translatedText)
           
        }).catch(error=>console.log('this is the error Data '+error))
        },

        //Set the range slider max value equal to audio duration
        initSlider() {
            var audio = this.$refs.player;
            if (audio) {
                this.audioDuration = Math.round(audio.duration);
            }
        },

        //Convert audio current time from seconds to min:sec display
        convertTime(seconds){
                            const format = val => `0${Math.floor(val)}`.slice(-2);
                //var hours = seconds / 3600;
                var minutes = (seconds % 3600) / 60;

                return [minutes, seconds % 60].map(format).join(":");

        },

        //Show the total duration of audio file
        totalTime() {
            var audio = this.$refs.player;
            if (audio) {
                var seconds = audio.duration;
                return this.convertTime(seconds);

            } else {
                return '00:00';
            }
        },

        //Display the audio time elapsed so far
        elapsedTime() {
            var audio = this.$refs.player;
            if (audio) {
                var seconds = audio.currentTime;
                return this.convertTime(seconds);

            } else {
                return '00:00';
            }
        },

        //Playback listener function runs every 100ms while audio is playing
        playbackListener() {

            var audio = this.$refs.player;

            //Sync local 'playbackTime' var to audio.currentTime and update global state
            this.playbackTime = audio.currentTime;
            
            //console.log("update: " + audio.currentTime);

            //Add listeners for audio pause and audio end events
            audio.addEventListener("ended", this.endListener);
            audio.addEventListener("pause", this.pauseListener);
        },

        //Function to run when audio is paused by user
        pauseListener() {
            this.isPlaying = false;
            this.listenerActive = false;
            this.cleanupListeners();
        },
        //Function to run when audio play reaches the end of file
        endListener() {
            this.isPlaying = false;
            this.listenerActive = false;
            this.cleanupListeners();
        },
        //Remove listeners after audio play stops
        cleanupListeners() {
            var audio = this.$refs.player;
            audio.removeEventListener("timeupdate", this.playbackListener);
            audio.removeEventListener("ended", this.endListener);
            audio.removeEventListener("pause", this.pauseListener);

            //console.log("All cleaned up!");
        },
        toggleAudio() {
            var audio = ""
             Vue.prototype.$audiopro.pause();
            if(this.texttospeech){
               
                
              const speech = new SpeechSynthesisUtterance()
              speech.voice = this.voices[2]
              speech.text = this.wordAudio
              speech.rate = 1
              speech.pitch = 1
              speech.volume =1
              speech.lang='en-US'
              window.speechSynthesis.speak(speech)

            } else {
                audio = this.$refs.player;
               
                if (audio.paused) {
                    audio.play();
                    this.isPlaying = true;
                } else {
                    audio.pause();
                    this.isPlaying = false;
                }
            }
            //var audio = document.getElementById("audio-player");
            
        },
    },
    mounted: function() {
        this.voices = window.speechSynthesis.getVoices();
        
        this.getpapago()
        
        this.$watch('url',()=>{
        this.$refs.player.load()
      })
      // nextTick code will run only after the entire view has been rendered
      this.$nextTick(function() {
        
        var audio=this.$refs.player;
        //Wait for audio to load, then run initSlider() to get audio duration and set the max value of our slider 
        // "loademetadata" Event https://www.w3schools.com/tags/av_event_loadedmetadata.asp
        audio.addEventListener(
          "loadedmetadata",
          function() {
            this.initSlider();
          }.bind(this)
        );

        // "canplay" HTML Event lets us know audio is ready for play https://www.w3schools.com/tags/av_event_canplay.asp
        audio.addEventListener(
          "canplay",
          function() {
            this.audioLoaded=true;
          }.bind(this)
        );

        //Wait for audio to begin play, then start playback listener function
        this.$watch("isPlaying",function() {

          if(this.isPlaying) {
            var audio=this.$refs.player;
            this.initSlider();
            //console.log("Audio playback started.");

            //prevent starting multiple listeners at the same time
            if(!this.listenerActive) {
              this.listenerActive=true;

              //for a more consistent timeupdate, include freqtimeupdate.js and replace both instances of 'timeupdate' with 'freqtimeupdate'
              audio.addEventListener("timeupdate",this.playbackListener);
            }
          }

        });

        //Update current audio position when user drags progress slider
        this.$watch("playbackTime",function() {
            // var audio=this.$refs.player;

        var diff=Math.abs(this.playbackTime-this.$refs.player.currentTime);
        
          //Throttle synchronization to prevent infinite loop between playback listener and this watcher
          if(diff>0.01) {
            this.$refs.player.currentTime=this.playbackTime;

          }

        });

      });
    }

};
</script>

<style>

/* Play/Pause Button */
.play-button{
    height: 45px
}

input[type="range"] {
    margin: auto;
    -webkit-appearance: none;
    position: relative;
    overflow: hidden;
    width: 100%;
    cursor: pointer;
    outline: none;
    border-radius: 0; /* iOS */
    background: transparent;
}

input[type="range"]:focus {
    outline: none;
}

::-webkit-slider-runnable-track {
    background: #fff;
}

/*
 * 1. Set to 0 width and remove border for a slider without a thumb
 */
::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 0; /* 1 */
    height: 40px;
    background: #fff;
    box-shadow: -100vw 0 0 100vw dodgerblue; 
    border: none; /* 2px solid #999; */
}

::-moz-range-track {
    height: 40px;
    background: #ddd;
}

::-moz-range-thumb {
    background: #fff;
    height: 40px;
    width: 0; /* 20px; */
    border: none; /* 3px solid #999; */
    border-radius: 0 !important;
    box-shadow: -100vw 0 0 100vw dodgerblue; 
    box-sizing: border-box;
}

::-ms-fill-lower {
    background: dodgerblue;
}

::-ms-thumb {
    background: #fff;
    border: 2px solid #999;
    height: 40px;
    width: 20px;
    box-sizing: border-box;
}

::-ms-ticks-after {
    display: none;
}

::-ms-ticks-before {
    display: none;
}

::-ms-track {
    background: #ddd;
    color: transparent;
    height: 40px;
    border: none;
}

::-ms-tooltip {
    display: none;
}
.volume-bar2{
    width:250px !important; height:8px !important;
}
.widthbox{
    width:500px !important;
}
@media only screen and (max-width: 1200px) {
.widthbox{
    width:200px !important;
}
.volume-bar2{
    width:220px !important; height:8px !important;
}
.font-14{
    font-size:14px !important
}
.font-12{
    font-size:12px !important
}
.font-10{
    font-size:8px !important
}
}
</style>
